"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-del-piano": {
    "eaa73403": [{
      "hkey": "6a13ed0f",
      "slug": "castel-del-piano",
      "name": "Castel del Piano",
      "primary": true,
      "skipSearch": false
    }],
    "monte-amiata-versante-grossetano": [{
      "hkey": "6a13ed0f",
      "slug": "castel-del-piano",
      "name": "Castel del Piano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;